module.exports = __webpack_public_path__ + "img/ROADMAP_Doki.55327d0b.png";